module.exports = __webpack_public_path__ + "static/media/group.4a7f7c26.svg";